<div class="assign-dialog">
  <h2 mat-dialog-title>Assign Documents</h2>
  <p class="subtitle">Selected documents: {{ data.selectedCount }}</p>

  <div mat-dialog-content>
    <mat-form-field appearance="outline" class="email-input">
      <mat-label>Add email addresses</mat-label>
      <mat-chip-list #chipList>
        <mat-chip 
          *ngFor="let email of emailList" 
          [selectable]="false"
          [removable]="true" 
          (removed)="removeEmail(email)"
        >
          {{ email }}
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip>
        <input
          placeholder="Type email and press Enter"
          [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matAutocomplete]="auto"
          [formControl]="emailCtrl"
          (matChipInputTokenEnd)="addEmail($event)"
          #emailSelectInput
        />
      </mat-chip-list>
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event.option.value); emailSelectInput.value = ''">
        <mat-option *ngFor="let email of filteredEmails | async" [value]="email">
          {{ email }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>

  <div mat-dialog-actions>
    <button mat-button (click)="onCancel()">Cancel</button>
    <button 
      mat-raised-button 
      color="primary" 
      [disabled]="emailList.length === 0"
      (click)="onSubmit()"
    >
      Assign
    </button>
  </div>
</div> 